'use client';

export { ShaderMount } from './shader-mount.js';
export type { ShaderMountProps, ShaderComponentProps } from './shader-mount.js';

export { MeshGradient, meshGradientPresets } from './shaders/mesh-gradient.js';
export type { MeshGradientProps } from './shaders/mesh-gradient.js';
export type { MeshGradientUniforms, MeshGradientParams } from '@paper-design/shaders';

export { SmokeRing, smokeRingPresets } from './shaders/smoke-ring.js';
export type { SmokeRingProps } from './shaders/smoke-ring.js';
export type { SmokeRingUniforms, SmokeRingParams } from '@paper-design/shaders';

export { NeuroNoise, neuroNoisePresets } from './shaders/neuro-noise.js';
export type { NeuroNoiseProps } from './shaders/neuro-noise.js';
export type { NeuroNoiseUniforms, NeuroNoiseParams } from '@paper-design/shaders';

export { DotOrbit, dotOrbitPresets } from './shaders/dot-orbit.js';
export type { DotOrbitProps } from './shaders/dot-orbit.js';
export type { DotOrbitUniforms, DotOrbitParams } from '@paper-design/shaders';

export { DotGrid, dotGridPresets } from './shaders/dot-grid.js';
export type { DotGridProps } from './shaders/dot-grid.js';
export type { DotGridUniforms, DotGridParams } from '@paper-design/shaders';

export { SimplexNoise, simplexNoisePresets } from './shaders/simplex-noise.js';
export type { SimplexNoiseProps } from './shaders/simplex-noise.js';
export type { SimplexNoiseUniforms, SimplexNoiseParams } from '@paper-design/shaders';

export { Metaballs, metaballsPresets } from './shaders/metaballs.js';
export type { MetaballsProps } from './shaders/metaballs.js';
export type { MetaballsUniforms, MetaballsParams } from '@paper-design/shaders';

export { Waves, wavesPresets } from './shaders/waves.js';
export type { WavesProps } from './shaders/waves.js';
export type { WavesUniforms, WavesParams } from '@paper-design/shaders';

export { PerlinNoise, perlinNoisePresets } from './shaders/perlin-noise.js';
export type { PerlinNoiseProps } from './shaders/perlin-noise.js';
export type { PerlinNoiseUniforms, PerlinNoiseParams } from '@paper-design/shaders';

export { Voronoi, voronoiPresets } from './shaders/voronoi.js';
export type { VoronoiProps } from './shaders/voronoi.js';
export type { VoronoiUniforms, VoronoiParams } from '@paper-design/shaders';

export { Warp, warpPresets } from './shaders/warp.js';
export type { WarpProps } from './shaders/warp.js';
export type { WarpUniforms, WarpParams, WarpPattern } from '@paper-design/shaders';

export { GodRays, godRaysPresets } from './shaders/god-rays.js';
export type { GodRaysProps } from './shaders/god-rays.js';
export type { GodRaysUniforms, GodRaysParams } from '@paper-design/shaders';

export { Spiral, spiralPresets } from './shaders/spiral.js';
export type { SpiralProps } from './shaders/spiral.js';
export type { SpiralUniforms, SpiralParams } from '@paper-design/shaders';

export { Swirl, swirlPresets } from './shaders/swirl.js';
export type { SwirlProps } from './shaders/swirl.js';
export type { SwirlUniforms, SwirlParams } from '@paper-design/shaders';

export { Dithering, ditheringPresets } from './shaders/dithering.js';
export type { DitheringProps } from './shaders/dithering.js';
export type { DitheringUniforms, DitheringParams } from '@paper-design/shaders';

export { GrainGradient, grainGradientPresets } from './shaders/grain-gradient.js';
export type { GrainGradientProps } from './shaders/grain-gradient.js';
export type { GrainGradientUniforms, GrainGradientParams } from '@paper-design/shaders';

export { PulsingBorder, pulsingBorderPresets } from './shaders/pulsing-border.js';
export type { PulsingBorderProps } from './shaders/pulsing-border.js';
export type { PulsingBorderUniforms, PulsingBorderParams } from '@paper-design/shaders';

export { ColorPanels, colorPanelsPresets } from './shaders/color-panels.js';
export type { ColorPanelsProps } from './shaders/color-panels.js';
export type { ColorPanelsUniforms, ColorPanelsParams } from '@paper-design/shaders';

export { StaticMeshGradient, staticMeshGradientPresets } from './shaders/static-mesh-gradient.js';
export type { StaticMeshGradientProps } from './shaders/static-mesh-gradient.js';
export type { StaticMeshGradientUniforms, StaticMeshGradientParams } from '@paper-design/shaders';

export { StaticRadialGradient, staticRadialGradientPresets } from './shaders/static-radial-gradient.js';
export type { StaticRadialGradientProps } from './shaders/static-radial-gradient.js';
export type { StaticRadialGradientUniforms, StaticRadialGradientParams } from '@paper-design/shaders';

export { PaperTexture, paperTexturePresets } from './shaders/paper-texture.js';
export type { PaperTextureProps } from './shaders/paper-texture.js';
export type { PaperTextureUniforms, PaperTextureParams } from '@paper-design/shaders';

export { FlutedGlass, flutedGlassPresets } from './shaders/fluted-glass.js';
export { type FlutedGlassProps } from './shaders/fluted-glass.js';
export { type FlutedGlassUniforms, type FlutedGlassParams } from '@paper-design/shaders';

export { Water, waterPresets } from './shaders/water.js';
export type { WaterProps } from './shaders/water.js';
export type { WaterUniforms, WaterParams } from '@paper-design/shaders';

export { ImageDithering, imageDitheringPresets } from './shaders/image-dithering.js';
export type { ImageDitheringProps } from './shaders/image-dithering.js';
export type { ImageDitheringUniforms, ImageDitheringParams } from '@paper-design/shaders';

export { Heatmap, heatmapPresets } from './shaders/heatmap.js';
export type { HeatmapProps } from './shaders/heatmap.js';
export type { HeatmapUniforms, HeatmapParams } from '@paper-design/shaders';

export { LiquidMetal, liquidMetalPresets } from './shaders/liquid-metal.js';
export type { LiquidMetalProps } from './shaders/liquid-metal.js';
export type { LiquidMetalUniforms, LiquidMetalParams } from '@paper-design/shaders';

export { HalftoneDots, halftoneDotsPresets } from './shaders/halftone-dots.js';
export type { HalftoneDotsProps } from './shaders/halftone-dots.js';
export type { HalftoneDotsUniforms, HalftoneDotsParams } from '@paper-design/shaders';

export { HalftoneCmyk, halftoneCmykPresets } from './shaders/halftone-cmyk.js';
export type { HalftoneCmykProps } from './shaders/halftone-cmyk.js';
export type { HalftoneCmykUniforms, HalftoneCmykParams } from '@paper-design/shaders';

export { GemSmoke, gemSmokePresets } from './shaders/gem-smoke.js';
export type { GemSmokeProps } from './shaders/gem-smoke.js';
export type { GemSmokeUniforms, GemSmokeParams } from '@paper-design/shaders';

export { isPaperShaderElement, getShaderColorFromString } from '@paper-design/shaders';
export type { PaperShaderElement, ShaderFit, ShaderSizingParams, ShaderSizingUniforms } from '@paper-design/shaders';

export {
  colorPanelsMeta,
  dotOrbitMeta,
  godRaysMeta,
  grainGradientMeta,
  meshGradientMeta,
  metaballsMeta,
  pulsingBorderMeta,
  simplexNoiseMeta,
  smokeRingMeta,
  swirlMeta,
  voronoiMeta,
  warpMeta,
  heatmapMeta,
  staticMeshGradientMeta,
  staticRadialGradientMeta,
} from '@paper-design/shaders';
